import defaultSymbolMap from './helpers/defaultMathSymbols';
const unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
function mergeSymbolMaps(additionalSymbols) {
    const symbolMap = {};
    symbolMap.symbols = additionalSymbols
        ? Object.assign(Object.assign({}, defaultSymbolMap.symbols), additionalSymbols.symbols) : Object.assign({}, defaultSymbolMap.symbols);
    return symbolMap;
}
function exec(operators, values) {
    const op = operators.pop();
    values.push(op.f(...[].concat(...values.splice(-op.argCount))));
    return op.precedence;
}
function calculate(expression, additionalSymbols) {
    const symbolMap = mergeSymbolMaps(additionalSymbols);
    let match;
    const operators = [symbolMap.symbols['('].prefix];
    const values = [];
    const pattern = new RegExp(`\\d+(?:\\.\\d+)?|${Object.keys(symbolMap.symbols)
        .map((key) => symbolMap.symbols[key])
        .sort((a, b) => b.symbol.length - a.symbol.length)
        .map((val) => val.regSymbol)
        .join('|')}|(\\S)`, 'g');
    pattern.lastIndex = 0;
    let afterValue = false;
    do {
        match = pattern.exec(expression);
        const [token, bad] = match || [')', undefined];
        const notNumber = symbolMap.symbols[token];
        const notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        const notAfterValue = !notNumber || (!notNumber.postfix && !notNumber.infix);
        if (bad || (afterValue ? notAfterValue : notNewValue)) {
            throw new Error('Syntax Error');
        }
        if (afterValue) {
            const curr = notNumber.postfix || notNumber.infix;
            do {
                const prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0)
                    break;
            } while (exec(operators, values));
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                if (afterValue)
                    exec(operators, values);
            }
        }
        else if (notNumber) {
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') {
                    throw new Error('Formula contains a function that needs parentheses ');
                }
            }
        }
        else {
            values.push(+token);
            afterValue = true;
        }
    } while (match && operators.length);
    if (operators.length) {
        throw new Error('Formula is missing closing parenthesis');
    }
    else if (match) {
        throw new Error('Formula has too many closing parentheses');
    }
    else {
        return values.pop();
    }
}
function reverseString(str) {
    return str
        .split('')
        .reverse()
        .join('');
}
export default function math(formula, additionalSymbols) {
    const reversedFormula = reverseString(formula);
    const formulaMatch = reversedFormula.match(unitRegExp);
    if (formulaMatch && !formulaMatch.every((unit) => unit === formulaMatch[0])) {
        throw new Error('All values in a formula must have the same unit or be unitless.');
    }
    const cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
    return `${calculate(cleanFormula, additionalSymbols)}${formulaMatch ? reverseString(formulaMatch[0]) : ''}`;
}
//# sourceMappingURL=math.js.map